// ResizeObserver错误抑制工具
// 这个错误通常由Element Plus等UI组件库引起，不影响实际功能

/**
 * 抑制ResizeObserver相关的错误
 * 这些错误通常是无害的，由组件重新渲染时的循环监听引起
 */
export function suppressResizeObserverErrors() {
  // 抑制控制台的ResizeObserver错误
  const originalError = console.error
  console.error = function(...args) {
    const message = args[0]
    if (typeof message === 'string' && 
        message.includes('ResizeObserver loop completed with undelivered notifications')) {
      // 忽略ResizeObserver错误，不输出到控制台
      return
    }
    // 其他错误正常输出
    originalError.apply(console, args)
  }

  // 处理webpack dev server的overlay错误
  const originalConsoleError = window.console.error
  window.console.error = function(...args) {
    const message = args[0]
    if (typeof message === 'string' && 
        (message.includes('ResizeObserver loop completed') ||
         message.includes('ResizeObserver loop limit exceeded'))) {
      return
    }
    originalConsoleError.apply(window.console, args)
  }

  // 处理webpack-dev-server的handleError函数
  if (window.__webpack_dev_server_overlay__) {
    const originalHandleError = window.__webpack_dev_server_overlay__.handleError
    if (originalHandleError) {
      window.__webpack_dev_server_overlay__.handleError = function(error) {
        if (error && error.message && 
            error.message.includes('ResizeObserver loop completed')) {
          return
        }
        return originalHandleError.call(this, error)
      }
    }
  }

  // 更全面的webpack-dev-server overlay错误处理
  if (window.__webpack_dev_server_overlay__) {
    // 拦截overlay的错误显示
    const overlay = window.__webpack_dev_server_overlay__
    if (overlay.handleError) {
      const originalHandleError = overlay.handleError.bind(overlay)
      overlay.handleError = function(error) {
        if (error && (
          (error.message && error.message.includes('ResizeObserver loop completed')) ||
          (error.toString && error.toString().includes('ResizeObserver loop completed'))
        )) {
          return
        }
        return originalHandleError(error)
      }
    }
  }

  // 全局window错误处理
  window.addEventListener('error', (event) => {
    if (event.message && 
        event.message.includes('ResizeObserver loop completed with undelivered notifications')) {
      event.preventDefault()
      event.stopPropagation()
      return false
    }
  }, true)

  // Promise rejection处理
  window.addEventListener('unhandledrejection', (event) => {
    if (event.reason && 
        typeof event.reason === 'string' && 
        event.reason.includes('ResizeObserver loop completed')) {
      event.preventDefault()
      return false
    }
  })
}

/**
 * 重写ResizeObserver以防止循环错误
 */
export function patchResizeObserver() {
  const OriginalResizeObserver = window.ResizeObserver
  
  if (OriginalResizeObserver) {
    window.ResizeObserver = class extends OriginalResizeObserver {
      constructor(callback) {
        super((entries, observer) => {
          // 使用 requestAnimationFrame 来延迟回调执行，避免循环
          requestAnimationFrame(() => {
            try {
              callback(entries, observer)
            } catch (error) {
              if (error.message && 
                  (error.message.includes('ResizeObserver loop completed') ||
                   error.message.includes('ResizeObserver loop limit exceeded'))) {
                // 忽略循环错误
                return
              }
              throw error
            }
          })
        })
      }
    }
  }
}

/**
 * 完全禁用 ResizeObserver 错误
 */
export function disableResizeObserverErrors() {
  // 覆盖全局错误处理
  const originalOnError = window.onerror
  window.onerror = function(message, source, lineno, colno, error) {
    if (typeof message === 'string' && 
        message.includes('ResizeObserver loop completed')) {
      return true // 阻止默认错误处理
    }
    if (originalOnError) {
      return originalOnError.call(this, message, source, lineno, colno, error)
    }
    return false
  }

  // 覆盖 Promise rejection 处理
  const originalOnUnhandledRejection = window.onunhandledrejection
  window.onunhandledrejection = function(event) {
    if (event.reason && 
        typeof event.reason === 'string' && 
        event.reason.includes('ResizeObserver loop completed')) {
      event.preventDefault()
      return true
    }
    if (originalOnUnhandledRejection) {
      return originalOnUnhandledRejection.call(this, event)
    }
    return false
  }
}

/**
 * 初始化所有错误抑制
 */
export function initErrorSuppression() {
  // 首先禁用全局错误
  disableResizeObserverErrors()
  
  // 然后抑制控制台错误
  suppressResizeObserverErrors()
  
  // 最后修补 ResizeObserver
  patchResizeObserver()
  
  console.log('🛡️ ResizeObserver错误抑制已启用')
}
